import React from 'react'
import $ from 'jquery';



const Modal =(props) => {

    let target = `#${props.modalid}`

    let okButton =  <button onClick={props.okButtonClick} data-bs-dismiss="modal" className=" btn btn-primary">{props.okButtonTitle}</button>
    if (props.okButton !== undefined) okButton = props.okButton

    let closeButton = <button  className="btn btn-secondary" data-bs-dismiss="modal">{props.closeButtonTitle}</button>
    if (props.closeButtonClick !== undefined) closeButton = <button onClick={props.closeButtonClick} className="btn btn-secondary" data-bs-dismiss="modal">{props.closeButtonTitle}</button>

    if (props.messagebox===true){
        okButton = null;
        closeButton = <button  className="btn btn-secondary" data-bs-dismiss="modal">OK</button>
        if (props.closeButtonTitle !== undefined)closeButton = <button  className="btn btn-secondary" data-bs-dismiss="modal">{props.closeButtonTitle}</button>
        if (props.closeButtonClick !== undefined) closeButton = <button onClick={props.closeButtonClick} className="btn btn-secondary" data-bs-dismiss="modal">{props.closeButtonTitle}</button>
    }

    if (props.showBottomButtons===false){
        okButton = null
       closeButton = null
    }

    let modalClassname= "modal-dialog"
    if (props.modalLarge)modalClassname= "modal-dialog modal-lg"
    if (props.modalExtraLarge)modalClassname= "modal-dialog modal-xl"
    if (props.modalSmall) modalClassname= "modal-dialog modal-sm"

 
    let additionalButton = null
    if (props.additionalButton !== undefined)additionalButton = props.additionalButton

    let backgroundstyle={}
    if (props.backgroundstyle) backgroundstyle = props.backgroundstyle

    if (props.closeButton !==undefined) closeButton = props.closeButton

    let onBlur = null
    if (props.onBlur !== undefined) onBlur=props.onBlur

    let modalStyle = {}
    if (props.modalStyle !==undefined) modalStyle = props.modalStyle

    let backdrop = true
    if (props.backdrop !== undefined){
        backdrop = props.backdrop
    }

    let header = (
        <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">{props.title}</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-hidden="true"></button>
        </div>
    )
    if (props.header !== undefined && props.header === false){
        header = null
    }
    let footer=(

        <div className="modal-footer">   
        {additionalButton}                     
        {okButton}
        {closeButton}
        </div>
    )
    if (props.footer !== undefined && props.footer === false){
        footer = null
    }

  

    return (
        <div>
            <button id={props.buttonid} style={{width:'0px', height:'0px', display:'none'}}   type="button" data-bs-toggle="modal" data-bs-target={target}/>
            <div className="modal fade" role="document" id={props.modalid} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" onBlur={onBlur}  data-bs-backdrop={backdrop}>
               
                    <div className={modalClassname} style={modalStyle}>
                        <div className="modal-content" style={backgroundstyle}>
                            {header}
                            <div className="modal-body">
                                {props.body}  
                            </div>
                            {footer}
                        </div>
                    </div>
            </div>
            
        </div>

            
    )
    
  
}



export default Modal;